<template>
    <b-container class="d-flex flex-column mw-100 mh-100 h-100 m-0 p-0 overflow-auto flex-wrap">
        <!-- Présentation du calendrier en semestre -->
        <b-row class="d-flex flex-row flex-wrap mh-100 h-100 m-0 p-0">
            <!-- Date de sélection -->
            <b-col class="border m-0 p-1 pl-2 font-weight-bold" hidden>
                {{ getSelectedDate(factorCalendarTypeEnum.Week, startPeriod, endPeriod) }}
            </b-col>
            <b-col class="flex-grow-1 m-0" v-for="(weekInfo,indexWeek) in weekInfos" :key="indexWeek">
                <b-row class="d-flex flex-column mh-100 h-100 flex-wrap">
                    <b-col class="border bg-gray-light pl-1 m-0 pt-1 pb-1 font-weight-bold text-center">
                        {{ weekInfo.dayName }}
                    </b-col>
                    <template v-for="(h,index) in weekInfo.hours">
                        <b-col class="w-100 d-flex d-inline flex-grow-1 border CalendarBorder"
                               :class="h.weekend ? 'bg-gray-light' : ''"
                               @click.stop="onClick($event, h.hourId)">
                            <b-row class="d-flex d-inline flex-wrap md-auto pl-1 CalendarDay" style="font-size:9px;"
                                   :ref="'mounth' + weekInfo.dayId + '_day' + h.hourNumber">
                                <b-col class="p-0 m-0 pl-1">
                                    <div class="d-flex align-items-center h-100 mh-100">
                                        <template v-if="h.hourNumber >= 10">
                                            <b> {{ h.hourNumber }}h</b>
                                        </template>
                                        <template v-else>
                                            <b style="color: transparent">0</b>
                                            <!-- Pour que les numéro soit tous alignés -->
                                            <b>{{ h.hourNumber }}h</b>
                                        </template>
                                    </div>
                                </b-col>
                            </b-row>


                            <template v-if="tooltipData[h.hourId] != undefined
                                    && weekInfo.hours[index] != undefined && Data?.findIndex(a=> a.noHour == h.hourId) >= 0
                                    && ('value' in Data?.find(a=> a.noHour == h.hourId))
                                    && Data?.find(a=> a.noHour == h.hourId).value != undefined
                                    && ((!tooltipData[h.hourId].isCalculate && tooltipData[h.hourId].values.length > 0 )
                                        || tooltipData[h.hourId].isCalculate)">
                                <b-row :id="weekInfo.dayId + '_hour' + h.hourId"
                                       style="font-size:9px;z-index:3; height: 100%"
                                       :style="'height:calc(' + tooltipData[h.hourId].nbPeriodValue * 100
                                                + '% + ' + ((tooltipData[h.hourId].nbPeriodValue - 1) * 2 * heightCalendarDay) + 'px; '"
                                       class="flex-grow-1 d-flex ml-4 text-white justify-content-center font-weight-bold border-0"
                                       :class="'bg-' + (tooltipData[h.hourId].isCalculate ? ColorCaclulateData :
                                                    ColorNotCaclulateData[tooltipData[h.hourId].values[0].periodicity])"
                                       @click.stop="onClick($event, h.hourId)">
                                    <b-row class="position-absolute text-white" align-v="start"
                                           style="font-size:9px;z-index: 4" v-if="!tooltipData[h.hourId].isFadeIn"
                                           :class="'border-' + (tooltipData[h.hourId].isCalculate ? ColorCaclulateData :
                                                    ColorNotCaclulateData[tooltipData[h.hourId].values[0].periodicity])">
                                        <!-- flèche du haut -->
                                        <b-col>
                                            <b-icon icon="triangle-fill"/>
                                        </b-col>
                                    </b-row>
                                    <b-row align-v="center">
                                        <b-col>
                                            <span class="shadow">
                                                {{ Intl.NumberFormat('fr-FR').format(tooltipData[h.hourId].value) }}
                                            </span>
                                        </b-col>
                                    </b-row>
                                    <b-row class="position-absolute text-white" align-v="end"
                                           style="font-size:9px;z-index: 4"
                                           v-if="!tooltipData[h.hourId].isFadeOut"
                                           :style="'height:calc(' + tooltipData[h.hourId].nbPeriodValue * 100
                                                + '% + ' + ((tooltipData[h.hourId].nbPeriodValue - 1) * 2 * heightCalendarDay) + 'px; '"
                                           :class="'border-' + (tooltipData[h.hourId].isCalculate ? ColorCaclulateData :
                                                    ColorNotCaclulateData[tooltipData[h.hourId].values[0].periodicity])">
                                        <!-- flèche du bas -->
                                        <b-col>
                                            <b-icon icon="triangle-fill" rotate="180"/>
                                        </b-col>
                                    </b-row>
                                </b-row>

                                <!-- Deuxième partie - la popup -->
                                <b-popover triggers="hover" placement="top"
                                           :target="weekInfo.dayId + '_hour' + h.hourId">
                                    <div class="m-0 p-1 d-flex flex-row flex-wrap" text-variant="dark">
                                        <div class="d-flex m-1 p-0">
                                            <div class="flex-column border p-1 m-0 text-center"
                                                 :class="'border-' + (tooltipData[h.hourId].isCalculate ? ColorCaclulateData :
                                                    ColorNotCaclulateData[tooltipData[h.hourId].values[0].periodicity])">
                                                <template v-if="tooltipData[h.hourId].isCalculate">
                                                    {{ getMomentDateToString(weekInfo.hours[index].date, true) }}
                                                </template>
                                                <template v-else>
                                                    {{ getMomentDateToString(tooltipData[h.hourId].values[0].startData.date, true) }}
                                                </template>
                                            </div>
                                            <div class="left-arrow"
                                                 :class="'bg-'+ (tooltipData[h.hourId].isCalculate ? ColorCaclulateData :
                                                    ColorNotCaclulateData[tooltipData[h.hourId].values[0].periodicity])"></div>
                                            <div
                                                class="pl-2 pr-2 m-0 flex-grow-1 mh-100 h-100 font-weight-bold text-white"
                                                :class="'bg-' + (tooltipData[h.hourId].isCalculate ? ColorCaclulateData :
                                                    ColorNotCaclulateData[tooltipData[h.hourId].values[0].periodicity]) +
                                              ' border-' + (tooltipData[h.hourId].isCalculate ? ColorCaclulateData :
                                                    ColorNotCaclulateData[tooltipData[h.hourId].values[0].periodicity])">
                                                    <span class="d-flex align-items-center h-100 mh-100">
                                                        {{ Intl.NumberFormat('fr-FR').format(tooltipData[h.hourId].value) }}
                                                    </span>
                                            </div>
                                            <div class="right-arrow"
                                                 :class="'bg-' + (tooltipData[h.hourId].isCalculate ? ColorCaclulateData :
                                                    ColorNotCaclulateData[tooltipData[h.hourId].values[0].periodicity]) +
                                              ' border-' + (tooltipData[h.hourId].isCalculate ? ColorCaclulateData :
                                                    ColorNotCaclulateData[tooltipData[h.hourId].values[0].periodicity])"></div>
                                            <div class="p-1 m-0 border text-center"
                                                 :class="'border-' + (tooltipData[h.hourId].isCalculate ? ColorCaclulateData :
                                                    ColorNotCaclulateData[tooltipData[h.hourId].values[0].periodicity])">
                                                <template v-if="tooltipData[h.hourId].isCalculate">
                                                    {{ getMomentDateToString(weekInfo.hours[index].date.add({day:1}), false) }}
                                                </template>
                                                <template v-else>
                                                    {{ getMomentDateToString(tooltipData[h.hourId].values[0].endData.date, false) }}
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </b-popover>
                            </template>
                        </b-col>
                    </template>
                </b-row>
            </b-col>
        </b-row>

    </b-container>
</template>

<script lang="ts">

import {Component, Prop, PropSync, Vue, Watch} from "vue-property-decorator";
import moment from "moment";
import {mixins} from "vue-class-component";
import {FactorUtils} from "@/components/commons/Factors/FactorUtils";
import FactorCalendarTypeEnum from "@/enums/FactorCalendarTypeEnum";
import locales from '../locales/FactorCalendarWeek.json';
import { Getter } from "vuex-class";

@Component({
    computed: {
        FactorCalendarTypeEnum() {
            return FactorCalendarTypeEnum
        }
    },
    methods: {},
    components: {},
    i18n:{messages:locales}
})
export default class FactorCalendarWeek extends mixins(Vue, FactorUtils) {
    @Prop()
    public Variant: string;

    @Getter('SessionStore/GetLanguage')
    private language!: string;

    /** Données du facteur sur cette période */
    @Prop()
    public Data!: any[];

    /** Premières Données du facteur en dehors de la période */
    @Prop()
    public OuterData!: any[];

    /** Pour l'affichage des données en tooltip */
    @PropSync("HoverDatas", {default: () => []})
    public hoverDatas!: any[];

    /** Paramètres transmis pour l'ajout, la modification/suppression des données*/
    @PropSync("ShowDatas", {default: () => []})
    public showDatas!: any[];
    @PropSync("ShowModal", {default: () => false})
    public showModal!: boolean;

    /** Date sélectionnée*/
    @Prop({default: () => Date.now()})
    public SelectedDate: Date;

    /** Couleur des données */
    @Prop({default: () => 'tertiary'})
    public ColorCaclulateData: string;
    @Prop({default: () => ['primary']})
    public ColorNotCaclulateData: string[];

    /** Facteur sélectionné */
    @Prop({default: () => {}})
    public SelectedFactor!: any;

    /** Période affichée */
    @PropSync("StartPeriod")
    public startPeriod: moment.Moment;
    @PropSync("EndPeriod")
    public endPeriod: moment.Moment;

    /** Pour accéder à l'enum dans la partie template */
    private factorCalendarTypeEnum = FactorCalendarTypeEnum;

    private weekInfos: {
        dayId: number, dayName: string, nbHours: number,
        hours: { date: moment.Moment, hourId: string, hourNumber: number, weekend: boolean }[]
    }[] = [];

    private heightCalendarDay: number = 0;

    /** Propriété pour la modale */
    private selectedDate: Date = new Date(Date.now());

    /** Informations des données par minutes et jours */
    private tooltipData: any = {};

    /**
     * Pour l'affectation de la variable privée selectedDate
     * @protected
     */
    @Watch('SelectedDate', {immediate: true})
    protected modifedDate() {
        console.debug('FactorCalendarWeek.vue - modifedDate');
        this.selectedDate = this.SelectedDate;
    }

    /**
     * Recalcule du calendrier à afficher
     * @protected
     */
    @Watch("SelectedDate")
    protected updateSelectedDate() {
        console.debug('FactorCalendarWeek.vue - SelectedDate');
        this.loadCalendar();
    }

    /**
     * Rechargement des listes liées aux données
     * @protected
     */
    @Watch("Data", {deep: true, immediate: true})
    protected setData() {
        console.debug('FactorCalendarWeek.vue - setData');
        this.tooltipData = {};
        this.loadDatas().then(() => {
        });
    }


    /**
     * Chargement de données pour les trier par minutes
     * @protected
     */
    protected loadDatas(): Promise<any> {
        return new Promise(async (resolve, reject) => {
            this.tooltipData = {};
            if (this.Data != undefined && this.Data.length > 0) {
                for (let i = 0; i < this.Data.length; i++) {
                    let datas = {...this.Data[i]};
                    this.tooltipData[datas.noHour] = datas;
                }
            }
            console.debug('FactorCalendarWeek.vue - loadDatas', this.tooltipData);
            resolve(true);
        });
    }

    /** Pour éviter les clicks intempestifs */
    private onClickDate: moment.Moment = moment();
    /**
     * Récupération des données au click pour l'ajout ou la modification/suppression des données à cette minute
     * @param evt
     * @param hour
     * @private
     */
    private onClick(evt, hour) {
        if (this.SelectedFactor != undefined && this.SelectedFactor != null) {
            console.debug('FactorCalendarWeek.vue - onClick - evt : %O - hour : %O', evt, hour);
            let datas: any[] = [];
            let minuteClick = 0;

            if (moment().diff(this.onClickDate) > 100) {
                this.onClickDate = moment();

                this.selectedDate = this.getNumberToDate(hour, 'hour').toDate();

                let hourDatas = this.Data.find(a => a.noHour == hour);
                if (!Array.isArray(hourDatas)) {
                    let hourDatasTemp = {...hourDatas};
                    hourDatas = [];
                    hourDatas.push(hourDatasTemp);
                }
                console.debug('FactorCalendarWeek.vue - onClick - hourDatas :', hourDatas);
                if (hourDatas.length > 0) {
                    if (!hourDatas[0].isCalculate) {
                        if (hourDatas[0].values.length > 0) {
                            let a = hourDatas[0].values[0];
                            console.debug('FactorCalendarWeek.vue - onClick - value :', a);
                            console.debug('FactorCalendarWeek.vue - onClick - startDate: ', a.startData.date);
                            let startDate = this.getMomentDate(a.startData.date, true);
                            console.debug('FactorCalendarWeek.vue - onClick - endDate :', a.endData.date);
                            let endDate = this.getMomentDate(a.endData.date, true);
                            console.debug('FactorCalendarWeek.vue - onClick - startDate : %O, endDate : %O', startDate, endDate);
                            if (this.SelectedFactor?.Temporality == 3 && a.startData.date != a.endData.date) {
                                datas.push({
                                    NoMonth: a.startData.noMonth,
                                    NoDay: a.startData.noDay,
                                    NoHour : a.startData.noHour,
                                    Status: 1,
                                    DataId: a.startData.id,
                                    StartDate: startDate?.format('YYYY-MM-DD'),
                                    StartTime: startDate?.format('HH:mm'),
                                    EndDate: startDate?.format('YYYY-MM-DD'),
                                    EndTime: startDate?.format('HH:mm'),
                                    Periodicity: a.periodicity,
                                    Value: a.startData.value, Unit: a.unit, Collapsed: false
                                });
                                datas.push({
                                    NoMonth: a.endData.noMonth,
                                    NoDay: a.endData.noDay,
                                    NoHour : a.endData.noHour,
                                    Status: 1,
                                    DataId: a.endData.id,
                                    StartDate: endDate?.format('YYYY-MM-DD'),
                                    StartTime: endDate?.format('HH:mm'),
                                    EndDate: endDate?.format('YYYY-MM-DD'),
                                    EndTime: endDate?.format('HH:mm'),
                                    Periodicity: a.periodicity,
                                    Value: a.endData.value,
                                    Unit: a.unit,
                                    Collapsed: false
                                });
                            } else {
                                datas.push({
                                    NoMonth: a.startData.noMonth,
                                    NoDay: a.startData.noDay,
                                    NoHour : a.startData.noHour,
                                    Status: 1,
                                    DataId: a.startData.id,
                                    StartDate: startDate?.format('YYYY-MM-DD'),
                                    StartTime: startDate?.format('HH:mm'),
                                    EndDate: endDate?.format('YYYY-MM-DD'),
                                    EndTime: endDate?.format('HH:mm'),
                                    Periodicity: a.periodicity,
                                    Value: a.value, Unit: a.unit, Collapsed: false
                                });
                            }
                            console.debug('FactorCalendarWeek.vue - onClick - datas :', datas);
                        }
                    } else {
                        this.$bvToast.toast(this.$t('UnableChangeCalculatedValue').toString(), { // $t('UnableChangeCalculatedValue') / Il n'est pas possible de changer la valeur calculée d'un facteur d'influence en mode Semestre. Veuillez sélectionner un autre mode d'affichage.
                            title: this.$t('ImpossibleEdit').toString(), // $t('ImpossibleEdit') / Modification impossible
                            autoHideDelay: 10000,
                            variant: "warning",
                            solid: true,
                            appendToast: true,
                            toaster: "b-toaster-top-center"
                        });
                        return;
                    }
                }

                console.debug('FactorCalendarWeek.vue - onClick - datas :', datas);
                if (datas.length > 0) {
                    datas[0].Collapsed = true;
                } else {
                    /** Ajout d'une nouvelle donnée */
                    console.debug('FactorCalendarWeek.vue - onClick - selectedDate :', this.selectedDate);
                    let date = this.getMomentDate(this.selectedDate, true);
                    date = moment({year: date.year(), month: date.month(), day: date.date(), hour : date.hour()});
                    console.debug('FactorCalendarWeek.vue - onClick - date :', this.getDateToNumber(date, 'day'));
                    let dataId = Math.abs(Math.min(...this.Data.map(a=> a.ids).flat())) ;
                    if (dataId ==  Infinity || isNaN(dataId)) {
                        dataId = 0;
                    }
                    let value = {
                        NoMonth: this.getDateToNumber(date, 'month'),
                        NoDay: this.getDateToNumber(date, 'day'),
                        NoHour : this.getDateToNumber(date, 'hour'),
                        Status: 0,
                        DataId: dataId * (-1) - 1,
                        StartDate: date.format('YYYY-MM-DD'),
                        StartTime: date?.format('HH:mm'),
                        EndDate: date.format('YYYY-MM-DD'),
                        EndTime: date?.format('HH:mm'),
                        Periodicity: 0,
                        Value: undefined,
                        Unit: this.SelectedFactor?.Unit,
                        Collapsed: true
                    };
                    console.debug('FactorCalendarWeek.vue - onClick - value :', value);
                    datas.push(value);
                }

                console.debug('FactorCalendarWeek.vue - onClick - datas :', datas);
                Vue.set(this, 'onClickDate', moment());
                Vue.set(this, 'showDatas', datas);
                Vue.set(this, 'showModal', datas.length > 0 && this.SelectedFactor.Temporality == 1 /* Limited */);
                console.debug('FactorCalendarWeek.vue - onClick - this.showDatas : %O - hour : %O', this.showDatas, hour);
            }
            this.onClickDate = moment();

            if (this.SelectedFactor.Temporality != 1 /* Limited */){
                this.$bvToast.toast(this.$t('UnableChangeFactor').toString(), { // $t('UnableChangeFactor') / "Il n'est pas encore possible de modifier des facteurs de type indexés ou instantanés.", { // 
                    title: this.$t('ImpossibleAction').toString(), // $t('ImpossibleAction') / "Action impossible",
                    autoHideDelay: 10000,
                    variant: "danger",
                    solid: true,
                    appendToast: true,
                    toaster: "b-toaster-top-center"
                });
            }
        }
    }

    /**
     * Chargement du calendrier
     * @private
     */
    private loadCalendar() {

        let startDate: moment.Moment = moment(moment(this.SelectedDate).clone().toDate());

        moment.locale(this.language);

        //let allDate: moment.Moment[] = [];
        this.weekInfos = [];
        startDate = moment(startDate.year() + '-' + (startDate.month() + 1 /* les mois commencent à 0. */) + '-' + startDate.date());
        startDate = startDate.clone().startOf('week');

        for (let i = 0; i < 7; i++) {
            let date = startDate.clone().add({days: i});

            let endDate = date.clone().add({day: 1});
            let nbHours = endDate.diff(date, 'hours');

            let hours: any[] = [];
            for (let i = 0; i < nbHours; i++) {
                let datehour = date.clone().add({hour: i});
                hours.push({
                    date: datehour,
                    hourId:  this.getDateToNumber(datehour, 'hour'),
                    weekend: date.weekday() == 5 || date.weekday() == 6, /* Moment in FR */
                    hourNumber: datehour.hours(),
                });
            }

            this.weekInfos.push({
                dayId: this.getDateToNumber(date, 'day'),
                dayName: date.format('dddd D MMMM'),
                nbHours: nbHours,
                hours: hours,
            });
        }

        let endDate: moment.Moment = startDate.clone().add({days: 7});
        this.startPeriod = startDate;
        this.endPeriod = endDate;

        console.debug('FactorCalendarWeek.vue - loadCalendar - startDate, endDate, weekInfos', startDate, endDate,
            this.weekInfos);
    }

    /** Au chargement */
    mounted() {
        this.loadCalendar();

        this.tooltipData = {};
        this.loadDatas().then(() => {
        });

        console.log('FactorCalendarWeek.vue - mounted');
        window.addEventListener('resize', this.getDimensions);
        this.getDimensions();
    }

    beforeDestroy() {
        console.log('FactorCalendarWeek.vue - unmounted');
        window.removeEventListener('resize', this.getDimensions);
    }

    /* le re-calcul de la hauteur de la bordure */
    updated() {
        console.log('FactorCalendarWeek.vue - updated');
        this.getDimensions();
    }

    /* pour le calcul de la hauteur de la bordure pour la taille des blocs */
    public getDimensions() {
        let elementCalendarDay = document.getElementsByClassName('CalendarDay');
        let elementCalendarBorder = document.getElementsByClassName('CalendarBorder');

        if (elementCalendarDay && elementCalendarBorder) {
            let boundingCalendarDay = (elementCalendarDay[1] as HTMLElement)?.getBoundingClientRect();
            let boundingCalendarBorder = (elementCalendarBorder[1] as HTMLElement)?.getBoundingClientRect();
            if(boundingCalendarBorder && boundingCalendarDay) {
                let calendarDayViewportY = (boundingCalendarDay.y || boundingCalendarDay.top);
                let calendarBorderViewportY = (boundingCalendarBorder.y || boundingCalendarBorder.top);
                this.heightCalendarDay = Math.abs(calendarDayViewportY - calendarBorderViewportY);
            }
        }
    }
}
</script>
<style scoped>

:deep(.shadow) {
    /* Plusieurs pour accentuer le contour. */
    text-shadow: 0 0 1px black, 0 0 1px black, 0 0 1px black, 0 0 1px black, 0 0 1px black, 0 0 1px black, 0 0 1px black,
    0 0 1px black, 0 0 1px black, 0 0 1px black, 0 0 1px black;
}

/** Style pour afficher dans le tooltip la flèche de droite */
:deep(.right-arrow) {
    position: relative;
    left: -1px;
    width: 15px !important;
    clip-path: polygon(0 0, 0 100%, 100% 50%);
}

/** Style pour afficher dans le tooltip la flèche de gauche */
:deep(.left-arrow) {
    position: relative;
    right: -1px;
    width: 15px !important;
    clip-path: polygon(100% 100%, 100% 0, 0 50%);
}

</style>